import Swiper, { Autoplay, Navigation, Pagination, Keyboard, EffectFade, Mousewheel, SwiperOptions } from "swiper";
import getImageTextSliderOptions from "../utils/image-text-options";
import { groupSlideroptions } from "../utils/group-slider-options";
import { logoSliderOptions } from "../utils/logo-slider-options";
import { newsFurtherOptions } from "../utils/news-further-options";
import { verticalSliderOptions } from "../utils/vertical-slider-options";
import { cardSliderOptions } from "../utils/card-slider-options";
import { cardSliderColumnOptions } from "../utils/card-slider-column-options";
import { initInstagramFeedSliders } from "../utils/instagram-slider-options";
import { initRelativeTimes } from "../utils/relative-time";
//Stage slider

new Swiper(".stageSlider", {
	modules: [Navigation, Pagination, Autoplay, EffectFade],
	effect: "fade",
	// If we need pagination
	pagination: {
		el: ".stage-swiper-pagination",
		clickable: true,
		type: "bullets",
	},
	autoplay: {
		delay: 2500,
		disableOnInteraction: false,
	},
});

//Home slider

new Swiper(".homeSlider", {
	modules: [Navigation, Autoplay, EffectFade],
	effect: "fade",
	grabCursor: true,
	navigation: {
		nextEl: ".homeSlider + .swiper-pagination-wrap .swiper-button-next",
		prevEl: ".homeSlider + .swiper-pagination-wrap .swiper-button-prev",
	},
	autoplay: {
		delay: 6000,
		disableOnInteraction: false,
	},
});

//Vertical slider
new Swiper(".verticalSlider", verticalSliderOptions as SwiperOptions);

//Image slider
const imageSlider = document.querySelectorAll(".imageSlider") as NodeListOf<HTMLElement>;
imageSlider.forEach((slider) => {
	const slidesPerViewAttr = slider.getAttribute("data-slides-per-view");
	const slidesPerView = slidesPerViewAttr ? parseInt(slidesPerViewAttr) : 0;
	const options = slidesPerView !== 5 ? getImageTextSliderOptions(slidesPerView) as SwiperOptions : logoSliderOptions as SwiperOptions;
	new Swiper(slider, options);
});


const groupSlider = new Swiper(".group-slider", groupSlideroptions as SwiperOptions);

const groupSliders = document.querySelectorAll(".group-slider") as NodeListOf<HTMLElement>;
groupSliders.forEach((groupSlider) => {
	const paginationCurrent = groupSlider.querySelector(".swiper-pagination-fraction .swiper-pagination-current") as HTMLElement;
	paginationCurrent.nextSibling?.replaceWith(" | ");
});
//Image gallery slider

new Swiper(".imageGallerySlider", {
	modules: [Navigation, Autoplay, EffectFade],
	effect: "fade",
	navigation: {
		nextEl: ".imageGallerySlider + .swiper-pagination-wrap .swiper-button-next",
		prevEl: ".imageGallerySlider + .swiper-pagination-wrap .swiper-button-prev",
	},
	autoplay: false,
});

//News slider
new Swiper(".news-further-images-slider", newsFurtherOptions as SwiperOptions);

// Card Slider
new Swiper(".card-slider", cardSliderOptions as SwiperOptions);

function initCardSliderColumn() {
	const cardSliderColumns = document.querySelectorAll(".icon-card-column-slider") as NodeListOf<HTMLElement>;
	cardSliderColumns.forEach((cardSliderColumn) => {
		let cardSliderColumnSlider: Swiper | undefined;
		function updateSlider() {
			if (window.innerWidth < 768 && cardSliderColumn) {
				if (!cardSliderColumnSlider) {
					cardSliderColumnSlider = new Swiper(cardSliderColumn, cardSliderColumnOptions as SwiperOptions);
				}
			} else {
				if (cardSliderColumnSlider) {
					cardSliderColumnSlider.destroy();
					cardSliderColumnSlider = undefined;
				}
			}
		}
		updateSlider();
		window.addEventListener("resize", updateSlider);
	});
}

initCardSliderColumn();

initInstagramFeedSliders();
initRelativeTimes();